<template>
  <div class="level">
    <div class="level-left">
      <div class="level-item">
        <span>{{$t('goto-page', 'Go to page')}}&nbsp;</span>
        <div class="control">
          <input type="number" class="input" style="width: 60px;" :min="1" :max="numPages" @change="$emit('update:currentPage', Number($event.target.value))">
        </div>
      </div>
      <div class="level-item">
        <nav class="pagination is-centered" role="navigation" aria-label="pagination">
          <a class="pagination-previous" @click.prevent="iteratePage(-1)" :disabled="currentPage === 1"><font-awesome-icon icon="chevron-left" /></a>
          <a class="pagination-next" @click.prevent="iteratePage(+1)" :disabled="currentPage === numPages"><font-awesome-icon icon="chevron-right" /></a>
          <ul class="pagination-list">
            <li v-for="(page, idx) in pageLinks" :key="`${page}#${idx}`">
              <span v-if="page === '...'" class="pagination-ellipsis">&hellip;</span>
              <a
                v-else
                @click.prevent="$emit('update:currentPage', page)"
                href=""
                class="pagination-link"
                :aria-label="`Go to page ${page}`"
                :class="currentPage === page && 'is-current'"
              >{{page}}</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="level-item">
        <div class="control">
          <div class="select">
            <select name="" id="" :value="itemsPerPage" @change="$emit('update:itemsPerPage', Number($event.target.value))">
              <option v-for="numItems in numItemsPerPageOptions" :key="numItems" :value="numItems">{{numItems}}</option>
              <option :value="-1">{{$t('all', 'All')}}</option>
            </select>
          </div>
        </div>
        <span>&nbsp;{{$t('items-per-page', 'items per page')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
// https://gist.github.com/kottenator/9d936eb3e4e3c3e02598#gistcomment-2899014
function pagination (currentPage, pageCount, delta = 2) {
  const separate = (a, b) => [a, ...({
    0: [],
    1: [b],
    2: [a + 1, b]
  }[b - a] || ['...', b])]

  return Array(delta * 2 + 1)
    .fill()
    .map((_, index) => currentPage - delta + index)
    .filter(page => page > 0 && page <= pageCount)
    .flatMap((page, index, { length }) => {
      if (!index) return separate(1, page)
      if (index === length - 1) return separate(page, pageCount)

      return [page]
    })
}

export default {
  props: {
    items: { type: Array, default: () => [] },
    currentPage: { type: Number, default: 1 },
    itemsPerPage: { type: Number, default: 10 },
    numItemsTotal: { type: Number, required: true },
    numItemsPerPageOptions: { type: Array, default: () => [10, 25, 50, 100] },
    numAdjacentPageLinks: { type: Number, default: 1 },
    defaultNumItemsPerPage: { type: Number, default: 25 }
  },
  created () {
    const idx = this.numItemsPerPageOptions.indexOf(this.defaultNumItemsPerPage) || 0
    this.$emit('update:itemsPerPage', this.numItemsPerPageOptions[idx])
  },
  watch: {
    numItemsTotal (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:currentPage', 1)
      }
    },
    itemsPerPage (newVal) {
      if (this.currentPage > this.numPages) {
        this.$emit('update:currentPage', this.numPages)
      }
    }
  },
  computed: {
    numPages () {
      return this.itemsPerPage > 0 ? Math.ceil(this.numItemsTotal / this.itemsPerPage) : 1
    },
    pageLinks () {
      return pagination(this.currentPage, this.numPages, this.numAdjacentPageLinks)
    }
  },
  methods: {
    iteratePage (offset) {
      this.$emit('update:currentPage', Math.max(1, Math.min(this.currentPage + offset, this.numPages)))
    }
  }
}
</script>
